import { IndexView } from '@app/modules/common/views';
import { Component } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { ActivatedRoute } from '@angular/router';
import { EmployeeAssetsTable } from '@app/modules/employees/services';
import { AuthService } from '@app/services';

@Component({
    templateUrl: './employee-assets-index.template.html',
    styleUrls: ['./employee-assets-index.style.scss'],
})
export class EmployeeAssetsIndexView extends IndexView {
    isLoading = true;

    employee: Employee;
    table: EmployeeAssetsTable;

    constructor(
        public auth: AuthService,
        protected route: ActivatedRoute
    ) {
        super();
        this.employee = this.route.snapshot.data.models.get('employee');
        this.table = new EmployeeAssetsTable(this.auth, this.employee);
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }
}
